<div class="container pl-5 pr-4">
    <header>
        <div class="d-flex align-items-center mt-3">     
            <h1 class="headline-4 pis">Peer To Peer</h1>
            <div class="card__right-side d-flex justify-content-end search ml-auto">
                <div class="search__icon-wrapper">
                  <i class="fas fa-search  input-prefix"></i>
                </div>
                <input [formControl]="search" class="form-control--search body-2" placeholder="Search Peer To Peer..." />
                <div class="search__icon-wrapper--cross px-1">
                    @if(search.value.length > 0) {
                        <span class="cursor--pointer" (click)="resetSearch()">X</span>
                    }
                </div>
            </div>
        </div>
        <span class="grey-text subtitle-2">You have a total of 
            <b class="black-text">
                {{P2PCampaigns.length}} campaigns
            </b>
        </span>
    </header>
    <div class="py-5">
        @if(filteredP2PCampaigns.length > 0) {
            <app-peer-to-peer-card *ngFor="let p2pCampaign of filteredP2PCampaigns; trackBy: trackById" [peerToPeer]="p2pCampaign"></app-peer-to-peer-card>
            <!-- @for (p2pCampaign of filteredP2PCampaigns; track p2pCampaign.id) {
                <app-peer-to-peer-card [peerToPeer]="p2pCampaign"></app-peer-to-peer-card>
            } -->
        } @else {
            <div class="d-flex justify-content-center">No Matching Campaigns</div>
        }
    </div>
</div>

